module.exports = __webpack_public_path__ + "static/media/oiui400_textstamp.75c573e3.ico";